import * as React from "react"
const EditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      fill="#4A4A4A"
      d="m6.016 2.46 3.446 3.446-4.727 4.733c-.22.22-.501.365-.807.418l-2.836.473a.608.608 0 0 1-.676-.416.615.615 0 0 1-.024-.284l.472-2.836c.053-.306.2-.588.42-.808L6.015 2.46Zm5.02-1.574a2.426 2.426 0 0 0-3.447 0l-.724.724 3.447 3.446.724-.724a2.425 2.425 0 0 0 0-3.446Z"
    />
  </svg>
)
export default EditIcon